/**
 * Product recommendations carousel functionality
 * Fetches and displays recommended products in a responsive slider
 * Used for "You may also like" and similar product suggestion sections
 */

(async () => {

  if (!customElements.get('product-recommendations')) {

    const { default: Swiper } = await import("swiper");
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 16,
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4
            }

          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.addEventListener("load", () => {
          this.init();
        });
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const source = html.querySelector('[data-recommended-products]');
              const target = this.querySelector('[data-recommended-products]');

              if (source && source.innerHTML && source.innerHTML.trim().length) {
                target.innerHTML = source.innerHTML;
              }

              this.swiperInstance.update();

              let productForms = this.querySelectorAll('product-form');
              productForms.forEach((productForm) => {
                // Only the drawer ProductForm (product-form.js) has getElements;
                // the cart-page one queries its elements in the constructor.
                productForm.getElements?.();
              });

          })
            .catch(e => {
              console.error(e);
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);

  }

})();
